import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import './index.css'
import { App } from './App'
import { registerServiceWorker } from './lib/offline/registerSW'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
)

// Register the service worker after render. Safe no-op in dev and when
// the virtual module is not available. Does not gate rendering.
registerServiceWorker()
